// @owners { team: patients }
import { isRebateProgram } from './isRebateProgram';

export type AttestationProgramContent = {
  pricingTitle: string;
  primaryCta: string;
  successToast: string;
};

const REBATE_CONTENT: AttestationProgramContent = {
  pricingTitle: 'Manufacturer discount available',
  primaryCta: 'Apply discount',
  successToast: 'Discount applied.',
};

const COPAY_CONTENT: AttestationProgramContent = {
  pricingTitle: 'Copay card available',
  primaryCta: 'Add copay card',
  successToast: 'Copay card added and saved to your profile.',
};

export const getAttestationProgramContent = (billableType: string): AttestationProgramContent => {
  if (isRebateProgram(billableType)) {
    return REBATE_CONTENT;
  }

  return COPAY_CONTENT;
};
